import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import useUser from '../../../Hooks/UserContext';

const PrivateRoute = (props) => {
  const user = useUser();
  const location = useLocation();

  const { children, to, redirect, hideToRepre, ...RouteProps } = props;

  let show = false;

  if (user) {
    if (typeof to == 'string') {
      show = user.tipo.includes(to);
    }
    if (typeof to == 'function') {
      show = to(user.tipo);
    }
    if (Array.isArray(to)) {
      show = to.map((p) => user.tipo.includes(p)).reduce((a, b) => a || b);
    }
    if (!to) {
      show = true;
    }
    if (typeof to == 'boolean') {
      show = to;
    }
    if (hideToRepre) {
      show = user.tipo.includes("REPRE") ? false : true;
    }
  }

  if (show) {
    if (children) {
      return (<Route {...RouteProps} > {children} </Route>);
    } else {
      return (<Route {...RouteProps} />);
    }
  } else {
    return <Route {...RouteProps}  ><Redirect to={{ pathname: redirect || '/Login', search: location.search }} /></Route>;
  }

};
export default PrivateRoute;
